"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldActionButton = void 0;
const react_1 = __importDefault(require("react"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const ControlPoint_1 = __importDefault(require("@material-ui/icons/ControlPoint"));
const action_button_1 = require("../action-button");
const table_field_toolbar_button_1 = require("../../../components/table-field/table-field-toolbar-button");
function TableFieldActionButton({ apiCall, ButtonComponent, ...restProps }) {
    const TableToolbarButtonComponent = ButtonComponent !== null && ButtonComponent !== void 0 ? ButtonComponent : TableFieldToolbarButtonWrapper;
    const handleApiCall = event_callback_hook_1.useEventCallback((formData) => {
        return apiCall(formData);
    });
    return (react_1.default.createElement(action_button_1.ActionButton, Object.assign({ ButtonComponent: TableToolbarButtonComponent, apiCall: handleApiCall }, restProps)));
}
exports.TableFieldActionButton = TableFieldActionButton;
function TableFieldToolbarButtonWrapper({ disabled, label, tooltip, ...rest }) {
    return (react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, Object.assign({ disabled: disabled !== null && disabled !== void 0 ? disabled : false, title: tooltip, show: true, IconComponent: ControlPoint_1.default }, rest)));
}
//# sourceMappingURL=table-field-action-button.js.map